export const VOUCHER_TYPE = {
  BOOKING: 'BOOKING',
  RESTAURANT: 'RESTAURANT', 
  DISCOUNT: 'DISCOUNT',
};

export const VOUCHER_STATUS = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  FULLY_REDEEMED: 'FULLY_REDEEMED',
  PARTIALLY_REDEEMED: 'PARTIALLY_REDEEMED',
  INACTIVE: 'INACTIVE',
};
